import { EncryptionKeyIdParamSchema, GetEncryptionKeyResponseSchema, ListEncryptionKeysRequestSchema, ListEncryptionKeysResponseSchema, } from '../../schemas.js';
/** REST contract for `insight-api/src/routes/encryption-keys.routes.ts`. */
export const providerEncryptionKeysContract = {
    list: {
        method: 'GET',
        path: '/provider/encryption-keys',
        query: ListEncryptionKeysRequestSchema,
        response: ListEncryptionKeysResponseSchema,
        responseStyle: 'parse-response',
        queryLimitMax: 100,
        errorMessage: 'Failed to list encryption keys',
    },
    getById: {
        method: 'GET',
        path: '/provider/encryption-keys/:keyId',
        pathParams: EncryptionKeyIdParamSchema,
        response: GetEncryptionKeyResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get encryption key',
    },
};
//# sourceMappingURL=provider-encryption-keys.contract.js.map